export default interface TariffModel {
  id: number;
  name: string;
  rate?: number;
}

export const deriveRawToTariff = (raw) => {
  return raw;
};

export const getTariffOptions = (tariffs) => {
  return [
    {
      labelText: 'Store Tariff Rate',
      value: '',
    },
    ...(tariffs || []).map((t) => ({
      labelText: t.name,
      value: t.id,
    })),
  ];
};

export const initialTariff = {
  id: 0,
  name: '',
  rate: 0,
};
